<template>
  <!-- <div class="home" @mousedown="clickMouseText"> -->
  <div class="home">
    <HomeHeader></HomeHeader>

    <!-- banner区域 开始 -->
    <div class="banner-bd">
      <div class="banner-bg"></div>
      <div class="banner-container">
        <div class="banner-swiper">
          <el-carousel
            indicator-position="none"
            height="480px"
            :initial-index="swiperIndex"
            @change="changeCarousel"
            ref="carousel"
          >
            <el-carousel-item
              class="swiper-wrapper"
              v-for="banner in homeData.banner"
              :key="banner.id"
            >
              <img :src="banner.image_url" :alt="banner.title + banner.id" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- banner区域 结束 -->

    <!-- 产业分类模块内容区域 开始 -->
    <div class="category-container w">
      <div class="number-category">
        <ul>
          <li>
            <span>山东公司</span>
            <!-- <span>业主</span> -->
          </li>
          <li>
            <span>海南公司</span>
            <!-- <span>天安全入住</span> -->
          </li>
          <li>
            <span>北京公司</span>
            <!-- <span>行业覆盖</span> -->
          </li>
          <li>
            <span>贵州公司</span>
            <!-- <span>行业覆盖</span> -->
          </li>
        </ul>
      </div>
      <!-- 第二种分类模块列表 开始 -->
      <div class="market-category">
        <div class="market-category-title">
          <span>主营产业</span>
          <!-- <span>我们是专业的</span> -->
        </div>
        <div class="market-category-content1">
          <a
            :href="zhuying.id === 4 ? '/project' : '/zhuying?id=' + zhuying.id"
            :class="{ 'init-module': twoMarket }"
            v-for="zhuying in homeData.zhuying"
            :key="zhuying.id"
          >
            <div class="market-category-content-bg">
              <img :src="zhuying.image_url" />
            </div>
            <div class="market-category-content-content">
              <div class="mccc-title">{{ zhuying.name }}</div>
              <div class="mccc-words">
                <span class="mccc-words-icon"></span>
                <span class="mccc-words-content"></span>
              </div>
              <div class="mccc-click">点击查看 ></div>
            </div>
          </a>
        </div>
      </div>
      <!-- 第二种分类模块列表 结束 -->
      <!-- 新闻模块 开始 -->
      <div class="news-category">
        <div class="news-category-header">
          <span
            @click="newSlideTo(1)"
            :class="newSwiperIndex == 1 ? 'span-active' : ''"
            >公司新闻</span
          >
          <span
            @click="newSlideTo(2)"
            :class="newSwiperIndex == 2 ? 'span-active' : ''"
            >项目新闻</span
          >
        </div>
        <div class="news-swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide news-content">
              <a
                :href="
                  news1.type == 1
                    ? 'http://www.sanfajituan.com/detail?id=' + news1.id
                    : news1.href
                "
                class="news-container"
                v-for="news1 in homeData.news1.data"
                :key="news1.id"
                target="_blank"
              >
                <div class="news-bg-img"><img :src="news1.image_url" /></div>
                <div class="news-card">
                  <div class="news-card-title">
                    {{ news1.title }}
                  </div>
                  <div class="news-card-times">
                    {{ news1.show_time ?? news1.update_time }}
                  </div>
                  <div
                    class="news-card-content"
                    v-html="
                      news1.description
                        ? news1.description.substring(0, 150)
                        : news1.content.substring(0, 150)
                    "
                  ></div>
                </div>
              </a>
            </div>
            <div class="swiper-slide news-content">
              <a
                :href="
                  news2.type == 1
                    ? 'http://www.sanfajituan.com/detail?id=' + news2.id
                    : news2.href
                "
                class="news-container2"
                v-for="news2 in homeData.news2.data"
                :key="news2.id"
                target="_blank"
              >
                <div class="news-bg-img"><img :src="news2.image_url" /></div>
                <div class="news-card">
                  <div class="news-card-title">{{ news2.title }}</div>
                  <div class="news-card-times">
                    {{ news2.show_time ?? news2.update_time }}
                  </div>
                  <div
                    class="news-card-content"
                    v-html="
                      news2.description
                        ? news2.description.substring(0, 150)
                        : news2.content.substring(0, 150)
                    "
                  ></div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻模块 结束 -->
    </div>
    <!-- 产业分类模块内容区域 结束 -->

    <HomeFooter></HomeFooter>
    <!-- 右下角视频 开始 -->
    <div
      class="video-tips animate__animated"
      :class="[toshowvideo ? 'animate__fadeIn' : 'none']"
      @click.stop="clickvideo"
    >
      <div class="tips-close" @click.stop="closeShowVideo"></div>
      <div class="video-bofang" :class="[hideBofang ? 'hide' : '']">
        <div class="video-mask"></div>
        <div class="video-wrap">
          <div class="video-close" @click.prevent="closeVideo"></div>
          <video
            src="https://lianyueit-shop.oss-cn-qingdao.aliyuncs.com/video/sf-video.943b9b9f.mp4"
            width="860"
            height="435"
            controls="controls"
            ref="videoGuanf1"
          >
            <source
              src="https://lianyueit-shop.oss-cn-qingdao.aliyuncs.com/video/sf-video.943b9b9f.mp4"
              type="video/mp4"
            />
            <p>
              哎，我发现一个问题，您家的浏览器好像不支持该视频的播放喔…请升级更高版本或使用其他浏览器查看试一下喔，么么哒…
            </p>
          </video>
        </div>
      </div>
    </div>
    <!-- 右下角视频 结束 -->
    <!-- 右侧服务滚动条 开始 -->
    <div class="ly-service">
      <div class="service_box service_consult">
        <div class="service_float service_con">
          <span class="right_triangle"></span>
          <div class="service_con_top">
            <div class="service_hint">
              <span class="service_icon"></span>
              <span>为保证服务质量，请先登录</span>
            </div>
            <div class="service_button">联系客服</div>
            <div class="service_button">加盟咨询</div>
          </div>
          <div class="service_phone">客服电话：400-777-9119</div>
        </div>
      </div>
      <div class="service_box service_yijian">
        <a href="/contact">
          <div class="service_float">
            <span class="right_triangle"></span>
            您的声音很有力量，我们渴望您的建议
          </div>
        </a>
      </div>
      <div class="service_box service_qr">
        <div class="service_float service_qrcon">
          <span class="right_triangle"></span>
          <div class="service_qrimg">
            <div class="service_qrimg_img"></div>
            微信扫一扫关注
          </div>
          <div class="service_qrtext">扫码了解更多营销技巧</div>
        </div>
      </div>
      <div
        class="service_box service_totop animate__animated"
        :class="[totop ? 'animate__fadeIn' : 'none']"
        @mousedown="uptoTop"
      >
        <div class="service_float">
          <span class="right_triangle"></span> 返回顶部
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import "animate.css";
import { getIndex } from "@/config/api";
import HomeHeader from "@/components/HomeHeader";
import HomeFooter from "@/components/HomeFooter";
export default {
  name: "HomeView",
  components: {
    HomeHeader,
    HomeFooter,
  },
  data() {
    return {
      mySwiper: "",
      myNewSwiper: "",
      swiperIndex: 0,
      newSwiperIndex: 1,
      a_idx: 0,
      totop: false,
      toshowvideo: false,
      hideBofang: true,
      oneMarket: false,
      twoMarket: false,
      homeData: {
        itemtitle: "",
        banner: [],
        news1: { data: [] },
        news2: { data: [] },
      }, //首页数据
    };
  },
  methods: {
    changeCarousel(index) {
      this.swiperIndex = index;
    },
    scrolling() {
      // 获取要定位元素距离浏览器顶部的距离
      // let navElement = document.getElementsByClassName("header");
      // let navH = navElement[0].offsetTop;
      let marketElement = document.getElementsByClassName("market-category");
      let marketH = marketElement[0].offsetTop;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // 滚动条滚动到600时显示返回顶部按钮
      this.totop = scrollTop >= 600 ? true : false;
      // 滚动条滚动到1024时显示视频
      this.toshowvideo = scrollTop >= 600 ? true : false;

      // 滚动条滚动到 .market-category-content 的时候，动态显示 .market-category-content
      // if (scrollTop > marketH - 700) {
      //   this.oneMarket = true;
      // }

      // 滚动条滚动到 .market-category-content1 的时候，动态显示 .market-category-content1
      if (scrollTop > marketH - 700) {
        this.twoMarket = true;
      }

      // console.log("aaaaaaaaa:", navH);
    },
    // 点击播放视频
    clickvideo() {
      this.hideBofang = false;
      this.$refs.videoGuanf1.play(); //播放
    },
    // 关闭播放视频
    closeVideo() {
      this.$refs.videoGuanf1.pause(); //暂停
      const videoItem = document.querySelector(".video-tips");
      videoItem.remove();
    },
    // 关闭展示视频图标
    closeShowVideo() {
      this.toshowvideo = false;
    },
    // 点击返回顶部
    uptoTop() {
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    // 鼠标点击屏幕出文字特效
    clickMouseText(e) {
      let a = new Array(
        "❤富强❤",
        "❤民主❤",
        "❤文明❤",
        "❤和谐❤",
        "❤自由❤",
        "❤平等❤",
        "❤公正❤",
        "❤法治❤",
        "❤爱国❤",
        "❤敬业❤",
        "❤诚信❤",
        "❤友善❤"
      );
      let spanElement = document.createElement("span");
      let spanElementText = document.createTextNode(a[this.a_idx]);
      this.a_idx = (this.a_idx + 1) % a.length;
      let x = e.pageX,
        y = e.pageY;
      spanElement.style.zIndex = 99999;
      spanElement.style.position = "absolute";
      spanElement.style.top = y - 20 + "px";
      spanElement.style.left = x + "px";
      spanElement.style.fontWeight = "bold";
      spanElement.style.color =
        "rgb(" +
        ~~(255 * Math.random()) +
        "," +
        ~~(255 * Math.random()) +
        "," +
        ~~(255 * Math.random()) +
        ")";
      spanElement.appendChild(spanElementText);
      document.body.appendChild(spanElement);
      let height = y - 20;
      let opacity = 1;
      let clickTimer = setInterval(() => {
        height = height - 20;
        opacity = opacity - 0.1;
        spanElement.style.top = height + "px";
        spanElement.style.opacity = opacity;
        if (opacity < 0) {
          clearInterval(clickTimer);
          spanElement.remove();
        }
      }, 100);
    },
    // 轮播图鼠标经过时暂停
    stopSwiper(num) {
      this.$refs.carousel.handleMouseEnter();
      if (typeof num == "number") {
        this.$refs.carousel.setActiveItem(num);
      }
    },
    // 轮播图鼠标离开时开始
    startSwiper() {
      this.$refs.carousel.handleMouseLeave();
    },
    // 新闻轮播图切换
    newSlideTo(num) {
      this.newSwiperIndex = num;
      this.myNewSwiper.slideTo(num);
    },
    fadein(ele, opacity, speed) {
      if (ele) {
        var v =
          ele.style.filter.replace("alpha(opacity=", "").replace(")", "") ||
          ele.style.opacity;
        v < 1 && (v = v * 100);
        var count = speed / 1000;
        var avg = count < 2 ? opacity / count : opacity / count - 1;
        var timer = null;
        timer = setInterval(function () {
          if (v < opacity) {
            v += avg;
            this.setOpacity(ele, v);
          } else {
            clearInterval(timer);
          }
        }, 500);
      }
    },
    fadeout(ele, opacity, speed) {
      if (ele) {
        var v =
          ele.style.filter.replace("alpha(opacity=", "").replace(")", "") ||
          ele.style.opacity ||
          100;
        v < 1 && (v = v * 100);
        var count = speed / 1000;
        var avg = (100 - opacity) / count;
        var timer = null;
        timer = setInterval(function () {
          if (v - avg > opacity) {
            v -= avg;
            this.setOpacity(ele, v);
          } else {
            clearInterval(timer);
          }
        }, 500);
      }
    },
    setOpacity(ele, opacity) {
      if (ele.style.opacity != undefined) {
        ///兼容FF和GG和新版本IE
        ele.style.opacity = opacity / 100;
      } else {
        ///兼容老版本ie
        ele.style.filter = "alpha(opacity=" + opacity + ")";
      }
    },
    getHome() {
      getIndex()
        .then((resp) => {
          if (resp.code === 0) {
            this.homeData = resp.data;
            window.document.title = "三发集团";
            // this.homeData?.itemtitle === undefined
            //   ? "三发集团"
            //   : this.homeData.itemtitle + "————三发集团";
            // console.log(this.homeData);
          } else {
            this.$message.error(resp.msg);
          }
        })
        .catch(() => {
          this.$message.error("获取数据失败");
        });
    },
  },
  mounted() {
    // 监听页面滚动事件
    window.addEventListener("scroll", this.scrolling);

    // 禁止右键复制
    document.oncontextmenu = new Function("event.returnValue=false;");
    document.onselectstart = new Function("event.returnValue=false;");

    this.myNewSwiper = new Swiper(".news-swiper-container", {
      autoplay: false,
      loop: true, // 循环模式选项
    });

    this.getHome();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrolling);
  },
};
</script>
<style lang="scss" scoped>
.banner-bd {
  height: 520px;
  .banner-container {
    height: 480px;
    .banner-swiper {
      width: 100%;
      .swiper-wrapper img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.market-category-content-bg {
  img {
    width: 100%;
    height: 184px;
  }
}
</style>
